import { render, staticRenderFns } from "./o-carousel.vue?vue&type=template&id=3371a93e"
import script from "./o-carousel.vue?vue&type=script&lang=js"
export * from "./o-carousel.vue?vue&type=script&lang=js"
import style0 from "./o-carousel.vue?vue&type=style&index=0&id=3371a93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports